var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPFeatureActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0417 15.8334L10.0001 18.7501L7.95841 15.8334H2.50008C2.27906 15.8334 2.06711 15.7456 1.91082 15.5893C1.75455 15.4331 1.66675 15.2211 1.66675 15.0001V3.33342C1.66675 3.1124 1.75455 2.90044 1.91082 2.74416C2.06711 2.58788 2.27906 2.50008 2.50008 2.50008H17.5001C17.7211 2.50008 17.9331 2.58788 18.0893 2.74416C18.2456 2.90044 18.3334 3.1124 18.3334 3.33342V15.0001C18.3334 15.2211 18.2456 15.4331 18.0893 15.5893C17.9331 15.7456 17.7211 15.8334 17.5001 15.8334H12.0417ZM11.1742 14.1667H16.6667V4.16675H3.33341V14.1667H8.82591L10.0001 15.8434L11.1742 14.1667Z",
    fill: "#8E68B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPFeatureActive);
export default __webpack_public_path__ + "static/media/p-feature-active.e8ecf012d0ed3bac4fd2b65c5f831165.svg";
export { ForwardRef as ReactComponent };